const homeLandingEN = {
	hero: {
		title:
			"Automate bookings, grow your business.",
		subtitle:
			"Sin Fila organizes your appointments, gives your business more visibility, and makes booking easy for your customers — all in one place.",
		primaryCta: "Register now for free",
		secondaryCta: "Explore Services",
		platformStrong: "Perfect for - ",
		platformRest: "Barbers • Salons • Spas • Tutors • Many more!",
		freeTrial: "14 day ",
		freeTrialText: "free trial. No commitment.", 
	},

	whatWeDo: {
		title: "Why businesses love Sin Fila",
		description:
			"Sin Fila connects businesses with clients through simple, fast, no-wait digital bookings.",
	},

	business: {
		title: "Key benefits for businesses",
		intro:
			"Organize your schedule, automate appointments, and avoid losing clients.",
		items: [
			"Receive online bookings 24/7",
			"Automatic confirmations and reminders",
			"Clear schedules with no overlaps",
			"Public profile to attract new clients",
			"Less time on WhatsApp — more time working",
		],
		cta: "Go to business area",
	},

	clients: {
		title: "Key benefits for customers",
		intro:
			"Book your appointment in seconds, without calls or waiting.",
		items: [
			"See real availability",
			"Book instantly",
			"Receive automatic reminders",
			"Reschedule or cancel stress-free",
			"Find barbershops, salons, and more near you",
		],
		cta: "Explore businesses",
	},

	about: {
		title: "How it works",
		step1: "Step 1",
		step1Text: "Sign up in 15 minutes — no contracts, no hassle.",
		step2: "Step 2",
		step2Text: "Your schedule, handled automatically.",
		step3: "Step 3",
		step3Text: "Bookings made easy.",
		paragraph1:
			"Create your business profile, list your services, set your hours, and get your calendar ready to receive bookings.",
		paragraph2:
			"Add your staff, assign roles, and manage multiple calendars. Automatic scheduling avoids double bookings and keeps your team organized.",
		paragraph3:
			"Clients can book online instantly. Confirmations, reminders, and notifications keep everyone in the loop.",
	},

	finalCta: {
		text: "Start free with a 14-day trial and earn with our referral program. For every successful referral, you both get 1 month free",
	},

	testimonials: {
		title: "What our clients are saying",
	},

	businessPoints: [
		{
			title: "Never miss a booking",
			desc: "All appointments, confirmations, and reminders in one place.",
		},
		{
			title: "Attract new clients and fill your schedule",
			desc: "Show your business to more clients in our marketplace.",
		},
		{
			title: "Save time managing your shop and staff",
			desc: "Manage your services and staff calendars effortlessly.",
		},
		{
			title: "Effortless bookings for your clients",
			desc: "Clients book, modify, and get reminders automatically.",
		},
	],
};

export default homeLandingEN;